import { assinaturaEdicao } from "./prontuario-attendance-texts";

export function novaEsperaConfirmada(res, req) {
  return res?.contrato === "NOVA_ESPERA_V1" && res.resultado === true && res.estado === "CONFIRMADO" && res.STATUS === "C" &&
    ["ID_CLIENT_REQUEST", "ID_AGENDA", "ID_PACIENTE", "ID_ATENDIMENTO", "ACAO"].every(k => String(res[k]) === String(req[k])) &&
    String(res.AGENDA?.ID_AGENDA) === String(req.ID_AGENDA) && String(res.AGENDA?.ID_PACIENTE) === String(req.ID_PACIENTE) &&
    res.AGENDA?.STATUS === "C" && typeof res.AGENDA.NOTAS === "string" &&
    (req.ACAO === "INICIAR" ? /\[[\s\S]+?\]/.test(res.AGENDA.NOTAS) : !/\[[\s\S]+?\]/.test(res.AGENDA.NOTAS));
}

export async function requisitarNovaEspera(api, jwt, { dados, consultar = false }) {
  if(!jwt.getToken()) { throw new Error("Sessão indisponível."); }
  api.setHeader();
  const { data } = await api.postOnce("agendamentos/access/" + (consultar ? "consultarNovaEspera" : "novaEsperaConfirmada"), dados, { timeout: 120000 });
  return data;
}

// A reserva local e o diário do backend impedem repetir a atualização em respostas perdidas.
export async function confirmarNovaEspera(vm, item, verificar) {
  if(item.novaEsperaConfirmada) { return item.novaEsperaConfirmada; }
  const req = item.opcoes.novaEspera;
  verificar();
  if(vm.appAllOnline === false) { throw new Error("A Nova Espera aguarda conexão para conferir a agenda."); }
  let resposta;
  if(!item.novaEsperaEnviada) {
    const reservado = await vm.reservarEtapaProntuario?.(item.req.ID_CLIENT_REQUEST, "nova-espera");
    verificar(); item.novaEsperaEnviada = true;
    try { if(reservado !== false) { resposta = await vm.alterarNovaEspera({ dados: req }); } } catch(error) { /* Consultar sem reenviar. */ }
    verificar();
  }
  if(!novaEsperaConfirmada(resposta, req)) {
    resposta = await vm.alterarNovaEspera({ dados: req, consultar: true }); verificar();
  }
  if(!novaEsperaConfirmada(resposta, req)) { throw new Error("A Nova Espera ainda não foi confirmada. Consulte a conclusão sem salvar o atendimento novamente."); }
  item.novaEsperaConfirmada = resposta;
  vm.agendamento = { ...vm.agendamento, ...resposta.AGENDA };
  return resposta;
}

const contexto = vm => JSON.stringify([vm.$route.fullPath, vm.idPaciente, vm.idAgenda, vm.idAtendimento, vm.usuario, vm.idEmitenteML]);
export async function iniciarOperacaoNovaEspera(vm, criarId, finalizar = false) {
  if(vm.novaEsperaOcupada || vm.isLoadingAtendimento || vm.salvandoAtendimentoEmCurso || vm.conclusaoAtendimentoEstado?.pendente ||
    vm.autoSaveSuspenso || vm.isLoadingAutoSave || vm.erroInicioAtendimento || vm.carregandoFichas || vm.erroFichas ||
    vm.textosAtendimentoEstado?.pendente || vm.cancelamentoPendente || vm.encerramentoEmCurso || vm.saidaPEPPreparada ||
    vm.recuperacaoOcupada || vm.erroRecuperacaoProntuario || vm.pendenciasRecuperaveis?.some(p => !p.resolvido) ||
    vm.configuracoesProntas === false || vm.appAllOnline === false || !vm.atendimentoIncluindo ||
    ![vm.idPaciente, vm.idAtendimento, vm.idAgenda].every(id => /^[1-9]\d*$/.test(String(id))) ||
    String(vm.agendamento?.ID_AGENDA) !== String(vm.idAgenda)) { return false; }
  const capturado = contexto(vm), assinatura = assinaturaEdicao(vm);
  const vigente = () => !vm.fichasEncerradas && contexto(vm) === capturado;
  vm.novaEsperaOcupada = true; vm.isLoadingAtendimento = true;
  try {
    let motivo = "";
    if(!finalizar) {
      const motivos = vm.motivosReEspera.slice();
      const resposta = await vm.$swal({ title: "Selecione o motivo de reespera", input: "radio", inputOptions: motivos,
        showCancelButton: true, cancelButtonText: "Cancelar",
        inputValidator: value => !/^\d+$/.test(String(value)) || !motivos[Number(value)] ? "Você precisa escolher um motivo!" : undefined });
      if(!vigente() || !resposta.isConfirmed) { return false; }
      if(!/^\d+$/.test(String(resposta.value)) || !motivos[Number(resposta.value)]) { return false; }
      motivo = motivos[Number(resposta.value)];
    }
    if(!vigente()) { return false; }
    if(assinaturaEdicao(vm) !== assinatura) { throw new Error("A edição mudou durante a seleção. Confira os dados antes de solicitar Nova Espera."); }
    const novaEspera = { ID_CLIENT_REQUEST: criarId(), ID_PACIENTE: vm.idPaciente, ID_ATENDIMENTO: vm.idAtendimento,
      ID_AGENDA: vm.idAgenda, ACAO: finalizar ? "FINALIZAR" : "INICIAR", MOTIVO: motivo };
    const opcoes = { novaEspera, somenteNovaEspera: finalizar, continuar: finalizar || vm.permanecePEPNovaEspera === "1",
      solicitarProcedimentosNovaEspera: !finalizar && vm.solicitarProcedimentoNovaEspera === "1",
      finalizar: false, naoValidarObrigatorios: true, naoDarMensagem: true };
    if(finalizar) { return await vm.concluirAtendimentoSalvo(opcoes); }
    return await vm.salvarAtendimentoLocal({ ...opcoes, atendimentos: vm.$refs.atendimentoInclusao.retornaFichaDados() });
  } catch(error) {
    if(vigente()) { vm.encerramentoMensagem = error.message || "Não foi possível concluir a Nova Espera. Confira o atendimento."; }
    return false;
  } finally {
    if(vigente()) { vm.novaEsperaOcupada = false; vm.isLoadingAtendimento = false; }
  }
}
